import { render } from "./ModalDelete.vue?vue&type=template&id=3bbdda5c&scoped=true"
import script from "./ModalDelete.vue?vue&type=script&lang=js"
export * from "./ModalDelete.vue?vue&type=script&lang=js"

import "./ModalDelete.vue?vue&type=style&index=0&id=3bbdda5c&scoped=true&lang=css"

import exportComponent from "/var/www/hrm-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bbdda5c"]])

export default __exports__